import useAuthForms from '../../../hooks/useAuthForms';
import { useForgotPasswordForm } from '../../../hooks/useForgotPasswordForm';
import StyledForm from '../../forms/shared/StyledForm';
import FormTextField from '../../molecules/form-elements/FormTextField';
import TurnstileChallenge from '../../shared/TurnstileChallenge';

const ForgotPasswordForm = () => {
  const { openLoginForm } = useAuthForms();
  const { t, control, errors, isSubmitting, handleClose, onSubmit, turnstile } = useForgotPasswordForm();

  return (
    <StyledForm
      onSubmit={onSubmit}
      onClose={handleClose}
      onBack={openLoginForm}
      submitTitle={t('forgotPassword.sendResetLink')}
      title={t('forgotPassword.title')}
      isSubmitting={isSubmitting}
      submitButton={{ disabled: !turnstile.isReady }}
    >
      <FormTextField
        name='email'
        control={control}
        label={t('register.email')}
        error={!!errors.email}
        helperText={errors.email?.message}
        disabled={isSubmitting}
        sx={{ minWidth: { xs: '100%', md: 400 } }}
      />
      <TurnstileChallenge {...turnstile.widgetProps} />
    </StyledForm>
  );
};

export default ForgotPasswordForm;
